import { UsersState } from "./types";

const initialState: UsersState = {
  data: [],
  isLoading: false,
  isCreating: false,
  isUpdating: false,
  isDeleting: false,
  pagination: {},
};

export default initialState;
